import { useEffect, VFC } from 'react'
import { useFormContext } from 'react-hook-form'
import { DEFAULT_IMAGE } from 'src/assets/images'
import { safetyOrange, truewhite } from 'src/styles/colors'
import { fontWeightBold } from 'src/styles/font'
import styled from 'styled-components'
import { FormItemProps, FormItemWrapper } from './common'

type FormImageProps = FormItemProps

export const FormImage: VFC<FormImageProps> = ({ ...props }) => {
  const { id } = props
  const { register, watch, setValue } = useFormContext()
  const image: string | undefined = watch(id)

  const onSelectFile = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files || !e.target.files.length) return
    if (image?.startsWith('blob')) window.URL.revokeObjectURL(image)
    setValue(id, window.URL.createObjectURL(e.target.files[0]))
  }

  useEffect(() => {
    register(id)
  }, [register, id])
  return (
    <FormItemWrapper {...props}>
      <FlexDiv>
        <label>
          <input
            type="file"
            accept="image/*"
            hidden
            id={id}
            onChange={onSelectFile}
          />
          <Icon src={image || DEFAULT_IMAGE} />
        </label>
        <FormLabel>
          <input
            type="file"
            accept="image/*"
            hidden
            id={id}
            onChange={onSelectFile}
          />
          画像を変更する
        </FormLabel>
      </FlexDiv>
    </FormItemWrapper>
  )
}

const FlexDiv = styled.div`
  display: flex;
  align-items: center;
`

const Icon = styled.img`
  border-radius: 50%;
  object-fit: cover;
  width: 140px;
  height: 140px;
  cursor: pointer;
`

const FormLabel = styled.label`
  width: 100%;
  max-width: 160px;
  height: 40px;

  margin-left: 32px;
  padding: 10px 30px;
  color: ${safetyOrange};
  background-color: ${truewhite};
  font-size: 14px;
  font-weight: ${fontWeightBold};
  text-align: center;
  white-space: nowrap;
  border-radius: 5px;
  border: solid 1px ${safetyOrange};
  cursor: pointer;
`
